import FeedContext from './FeedContext';
import withFeedContextProvider from './withFeedContextProvider';

export default FeedContext;
export {
  withFeedContextProvider,
};
